import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import '../../gallery/components/GalleryItem.scss';
import ShareButton from '../../common/components/ShareButton';
import {Point} from '../../admin/artisticobjects/types/Image';
import {getObjectPosition} from '../../common/utils/imageUtils';

interface PlaceItemProps {
  title: string;
  organizationalUnit: string;
  image: {
    src: string;
    alt: string;
    focalPoint?: Point;
    size?: { width: number; height: number };
  };
  caption?: string;
  town: string;
  zoomedIn: boolean;
  withDescriptions: boolean;
  placeId: string;
}

const PlaceItem: React.FC<PlaceItemProps> = ({
  title,
  organizationalUnit,
  image,
  caption,
  town,
  zoomedIn,
  withDescriptions,
  placeId
}) => {
  const {t} = useTranslation();

  const placeUrl = `/gallery/place/${placeId}`;
  const imageStyle = getObjectPosition(image.focalPoint, image.size);

  return (
    <div className="gallery-item bg-white rounded shadow-sm overflow-hidden">
      <Link to={placeUrl} className="block h-64 overflow-hidden relative flex justify-center bg-black">
        <img
          className={`zoomedIn ${zoomedIn ? 'w-full' : ''} h-full object-cover`}
          src={image.src}
          alt={image.alt}
          style={imageStyle}
        />
        {caption && (
          <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded-sm">
            {caption}
          </div>
        )}
      </Link>
      <div className={`p-4 ${withDescriptions ? '' : 'hidden'}`}>
        <h3 className="gallery-item-title font-medium text-gray-900">
          <Link to={placeUrl} className="hover:text-gray-800 hover:underline">
            {title}
          </Link>
        </h3>
        <div className="flex justify-between items-top gap-2 mt-2 text-sm text-gray-600">
          <Link to={`/locations?ou[]=${organizationalUnit}`} className="hover:text-gray-800 hover:underline">
            {organizationalUnit}
          </Link>
          <Link to={`/locations?town=${town}`} className="hover:text-gray-800 hover:underline">
            {town}
          </Link>
        </div>
        <div className="flex items-center mt-3">
          <button className="text-gray-500 hover:text-gray-700" data-testid="toggle-favourite">
            <i className="fa fa-heart"/>
          </button>
          <ShareButton
            title={title}
            text={`${title} - ${town}`}
            url={`${window.location.origin}/gallery/place/${placeId}`}
            className="text-gray-500 hover:text-gray-700 ml-3"
          />
          <Link
            to={placeUrl}
            className="ml-auto bg-gray-800 hover:bg-black text-white text-xs px-3 py-1 rounded-sm"
          >
            {t('gallery.item.viewDetails')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PlaceItem;

